import { render } from "./SelfRegistrationLagos.vue?vue&type=template&id=697b8ddf&scoped=true"
import script from "./SelfRegistrationLagos.vue?vue&type=script&lang=js"
export * from "./SelfRegistrationLagos.vue?vue&type=script&lang=js"

import "./SelfRegistrationLagos.vue?vue&type=style&index=0&id=697b8ddf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-697b8ddf"]])

export default __exports__